import { NgModule } from '@angular/core';
import { ClientProspectComponent } from './client-prospect.component';
import { CommonModule } from '@angular/common';  
import { QuestionModule } from './components/question/question.module';
import { IncompleteFormModule } from './components/incomplete-form/incomplete-form.module';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [
    ClientProspectComponent
  ],
  imports: [
    CommonModule,
    QuestionModule,
    IncompleteFormModule,
    IonicModule
  ],
  exports: [
    ClientProspectComponent
  ]
})
export class ClientProspectModule { }
